"use client";

import { c as _c } from "react/compiler-runtime";
import { Link as HeroLink } from "@heroui/react";
import NextLink from "next/link";
import { cn } from "../../lib/utils";
export const Link = t0 => {
  const $ = _c(15);
  let className;
  let href;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      href,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = href;
    $[3] = props;
  } else {
    className = $[1];
    href = $[2];
    props = $[3];
  }
  if (href) {
    let t1;
    if ($[4] !== className) {
      t1 = cn(className);
      $[4] = className;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    let t2;
    if ($[6] !== href || $[7] !== props || $[8] !== t1) {
      t2 = <HeroLink as={NextLink} href={href} className={t1} {...props} />;
      $[6] = href;
      $[7] = props;
      $[8] = t1;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    return t2;
  }
  let t1;
  if ($[10] !== className) {
    t1 = cn(className);
    $[10] = className;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  let t2;
  if ($[12] !== props || $[13] !== t1) {
    t2 = <HeroLink className={t1} {...props} />;
    $[12] = props;
    $[13] = t1;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  return t2;
};